import { Component, inject, input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SelectionInput } from "common/form/input/types/selection-input";
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { ChatbotResource } from "core/stages-client";
import { AsyncPipe } from "@angular/common";
import { InputComponent } from "common/form/input/input.component";

@Component({
	selector: "stages-chatbot-settings",
	templateUrl: "./chatbot-settings.component.html",
	styleUrls: ["./chatbot-settings.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [AsyncPipe, ReactiveFormsModule, InputComponent],
})
export class ChatbotSettingsComponent implements OnInit {
	readonly settings$ = input.required<Promise<stages.chatbot.Settings>>();

	private readonly formBuilder = inject(FormBuilder);
	private chatbotResource = inject(ChatbotResource);

	protected form = new UntypedFormGroup({});
	protected personalityInput!: SelectionInput;

	// eslint-disable-next-line @typescript-eslint/no-misused-promises -- TODO: Remove this comment and fix warnings!
	async ngOnInit(): Promise<void> {
		const settings = await this.settings$();
		const selectedPersonality = [settings.personality ?? settings.personalities[0].id!];
		this.personalityInput = new SelectionInput({
			key: "personality",
			translateKey: "chatbot.settings.personality",
			value: selectedPersonality,
			selectionOptions: settings.personalities.map((p) => ({
				value: p.id!,
				untranslatableName: p.name,
			})),
		});
		this.form = this.formBuilder.group({
			personality: this.formBuilder.control(selectedPersonality),
		});
	}

	protected async save(settings: stages.chatbot.Settings): Promise<void> {
		settings.personality = this.form.controls.personality.value[0];
		await this.chatbotResource.saveSettings(settings);
	}
}
